let now = null;

export default function runInLast(fn) {
  now = new Date().getTime();

  const args = Array.prototype.slice.call(arguments);
  args.shift();

  return run(fn, args, now)();
}

function run(fn, args, time) {
  return function() {
    return new Promise(function(resolve) {
      fn.apply(this, args).then(data => {
        if (time == now) {
          resolve(data);
        }
      });
    });
  }
}
